import React from 'react';

const TickRoundelIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='none' fillRule='evenodd'>
      <circle cx='16' cy='16' r='12' fill='#0DA003' />
      <g fill='#FFF' transform='translate(8.100505, 10.636039)'>
        <rect
          width='2'
          height='15'
          x='9.253'
          y='-1.49'
          rx='1'
          transform='translate(10.253048, 6.010408) rotate(45.000000) translate(-10.253048, -6.010408)'
        />
        <rect
          width='8'
          height='2'
          x='-.464'
          y='7.485'
          rx='1'
          transform='translate(3.535534, 8.485281) rotate(45.000000) translate(-3.535534, -8.485281)'
        />
      </g>
    </g>
  </svg>
);

export default TickRoundelIcon;
